import { createFileRoute } from "@tanstack/react-router";
import { LocationPage } from "@/components/site/location-page";
import { localBusinessJsonLd, serviceJsonLd } from "@/components/site/jsonld";
import { AREA_PAGES } from "@/lib/site";

const P = AREA_PAGES.find((p) => p.slug === "bilvask-mjondalen")!;

export const Route = createFileRoute("/bilvask-mjondalen")({
  head: () => ({
    meta: [
      { title: P.title },
      { name: "description", content: P.desc },
      { property: "og:title", content: P.title },
      { property: "og:description", content: P.desc },
      { property: "og:type", content: "website" },
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(localBusinessJsonLd()) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd(P.h1, P.desc)) },
    ],
  }),
  component: () => <LocationPage slug="bilvask-mjondalen" />,
});
